export default __webpack_public_path__ + "static/media/I.51d6186b.svg";